import React from "react";

const WitnessList = React.lazy(() => import('src/pages/witness/WitnessList'));
const AddWitness = React.lazy(() => import('src/pages/witness/AddWitness'));
const EditWitness = React.lazy(() => import('src/pages/witness/EditWitness'));

const routes = [
    { path: '/dashboard/witness-list/add', name: 'Add', element: AddWitness },
    { path: '/dashboard/witness-list/edit', name: 'Edit', element: EditWitness },
    { path: '/dashboard/witness-list', name: 'Witnesses Setting', element: WitnessList },
];

export default routes;
